import type { ImgHTMLAttributes } from 'react';

import { useColorTheme } from '@/hooks/domain/useColor';

const MissingChartIcon = (props: ImgHTMLAttributes<HTMLImageElement>) => {
  const colorTheme = useColorTheme();
  return (
    <img
      src={`/assets/missing-chart_${colorTheme}.png`}
      alt="missing-chart"
      {...props}
    />
  );
};

export default MissingChartIcon;
